import { render, staticRenderFns } from "./FluxVortex.vue?vue&type=template&id=40d6bbad&"
import script from "./FluxVortex.vue?vue&type=script&lang=js&"
export * from "./FluxVortex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports